const arrowTypeData = ['default', 'primary'];

export default arrowTypeData;
